var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1166,
    cy: 22.1166,
    r: 22.1166,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3722 22.3722C21.3585 22.3722 20.4908 22.0113 19.7689 21.2894C19.047 20.5676 18.6861 19.6998 18.6861 18.6861C18.6861 17.6724 19.047 16.8047 19.7689 16.0828C20.4908 15.3609 21.3585 15 22.3722 15C23.3859 15 24.2537 15.3609 24.9755 16.0828C25.6974 16.8047 26.0583 17.6724 26.0583 18.6861C26.0583 19.6998 25.6974 20.5676 24.9755 21.2894C24.2537 22.0113 23.3859 22.3722 22.3722 22.3722ZM15 27.9014V27.1642C15 26.642 15.1344 26.162 15.4032 25.7243C15.6719 25.2865 16.029 24.9525 16.4744 24.7221C17.4267 24.246 18.3943 23.8889 19.3773 23.6508C20.3602 23.4128 21.3585 23.2937 22.3722 23.2937C23.3859 23.2937 24.3842 23.4128 25.3672 23.6508C26.3501 23.8889 27.3177 24.246 28.27 24.7221C28.7154 24.9525 29.0725 25.2865 29.3413 25.7243C29.61 26.162 29.7444 26.642 29.7444 27.1642V27.9014C29.7444 28.4082 29.564 28.8421 29.203 29.203C28.8421 29.564 28.4082 29.7444 27.9014 29.7444H16.8431C16.3362 29.7444 15.9023 29.564 15.5414 29.203C15.1805 28.8421 15 28.4082 15 27.9014Z",
    fill: "#B97DA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumUsers);
export default __webpack_public_path__ + "static/media/premium-users.d47fabf9d6d743e00cf75b4b245f643b.svg";
export { ForwardRef as ReactComponent };